import React from 'react';
import { MessageCircle, Star, Layers, Heart, Briefcase, Hash, Phone, Signature, Compass } from 'lucide-react';
import { openWhatsApp } from '../../lib/whatsapp';

// Order per brief: Kundali, Tarot, Love/Marriage, Career, Numerology, Mobile Number, Name, Spiritual
const services = [
  {
    id: 'kundali',
    icon: Star,
    title: 'Kundali Analysis',
    description: 'Personalised Vedic birth chart covering career, marriage, finance and life direction.',
    message: 'Namaste Nitika Ji, I would like to book a Kundali Analysis consultation.'
  },
  {
    id: 'tarot',
    icon: Layers,
    title: 'Tarot Card Reading',
    description: 'Intuitive tarot for clarity on decisions, timing and what is unfolding now.',
    message: 'Namaste Nitika Ji, I would like to book a Tarot Card Reading.'
  },
  {
    id: 'love-marriage',
    icon: Heart,
    title: 'Love & Marriage Guidance',
    description: 'Compatibility, marriage timing and relationship clarity through Vedic astrology.',
    message: 'Namaste Nitika Ji, I would like guidance on love, marriage and relationships.'
  },
  {
    id: 'career',
    icon: Briefcase,
    title: 'Career & Business Guidance',
    description: 'Astrological insight on career direction, business decisions and financial cycles.',
    message: 'Namaste Nitika Ji, I would like guidance on my career and business.'
  },
  {
    id: 'numerology',
    icon: Hash,
    title: 'Numerology Consultation',
    description: 'Full numerology analysis of your birth date and name numbers with practical guidance.',
    message: 'Namaste Nitika Ji, I would like to book a Numerology Consultation.'
  },
  {
    id: 'mobile-number',
    icon: Phone,
    title: 'Mobile Number Numerology',
    description: 'Analysis and correction of your mobile number for aligned personal and financial energy.',
    message: 'Namaste Nitika Ji, I would like to get my mobile number analysed and corrected according to numerology.'
  },
  {
    id: 'name',
    icon: Signature,
    title: 'Name Numerology & Correction',
    description: 'Analysis of your name spelling and vibration, with recommended corrections if needed.',
    message: 'Namaste Nitika Ji, I would like to get my name analysed and corrected according to numerology.'
  },
  {
    id: 'spiritual',
    icon: Compass,
    title: 'Spiritual Guidance',
    description: 'Holistic remedies, mantras and gentle counsel to help you find balance and calm.',
    message: 'Namaste Nitika Ji, I would like spiritual guidance and remedies.'
  }
];

export const AllServices = () => {
  return (
    <section id="services" className="py-16 sm:py-20 bg-gradient-to-b from-[#0A0000] via-[#120606] to-[#0A0000]">
      <div className="container mx-auto px-4 max-w-6xl">
        <p className="text-[11px] tracking-[0.2em] uppercase text-[#D4AF37] text-center mb-3 font-medium">
          How Nitika Can Help You
        </p>
        <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl text-center text-white mb-3 font-medium">
          Complete Guidance Services
        </h2>
        <p className="text-center text-[#A89B8C] text-sm sm:text-base max-w-xl mx-auto mb-10">
          Personally delivered on WhatsApp. Choose the service that fits your question.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="all-services-grid">
          {services.map((s) => (
            <div
              key={s.id}
              className="bg-black/50 border border-[#D4AF37]/15 rounded-xl p-5 flex flex-col hover:border-[#D4AF37]/40 transition-colors duration-200"
              data-testid={`service-card-${s.id}`}
            >
              <div className="w-10 h-10 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/25 flex items-center justify-center mb-4">
                <s.icon className="w-4 h-4 text-[#D4AF37]" strokeWidth={1.75} />
              </div>
              <h3 className="text-base font-medium text-white font-['Cormorant_Garamond'] mb-1.5 leading-snug">
                {s.title}
              </h3>
              <p className="text-[#A89B8C] text-[13px] leading-relaxed mb-5 flex-1">
                {s.description}
              </p>
              <button
                type="button"
                onClick={() => openWhatsApp(s.message)}
                className="inline-flex items-center justify-center gap-1.5 bg-gradient-to-r from-[#F3E5AB] via-[#D4AF37] to-[#AA8022] text-black text-xs font-semibold py-2 px-3 rounded-full hover:shadow-md transition-shadow duration-200"
                data-testid={`service-cta-${s.id}`}
              >
                <MessageCircle className="w-3.5 h-3.5" />
                Book on WhatsApp
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
